<template>
    <div class="remodal" data-remodal-id="modal" data-remodal-options="hashTracking: false">
        <button data-remodal-action="close" class="remodal-close"></button>
        <h3 class="title">Create encrypted keystore file (UTC / JSON)</h3>
        <form @submit.prevent="save">
            <div>
                <input class="hidden" type="text" autocomplete="username" />
                <input
                    :type="showPassword ? 'text' : 'password'"
                    autocomplete="new-password"
                    class="text-input-large"
                    v-model="password"
                    placeholder="Password"
                />
                <button type="button" class="show-password" @click="showPassword = !showPassword">
                    <i :class="showPassword ? 'icon-eye-off' : 'icon-eye-on'"></i>
                </button>
            </div>
            <div>
                <button
                    type="button"
                    class="button-large"
                    @click="save"
                    :disabled="!password || !privateKey || loading"
                    v-text="loading ? 'Generating...' : 'Download'"
                ></button>
            </div>
        </form>
    </div>
</template>

<script>
    import 'remodal/src/remodal';
    import * as download from 'downloadjs';
    import { Wallet } from 'ethers';

    export default {
        props: {
            address: String,
            privateKey: String,
        },
        data: function () {
            return {
                showPassword: false,
                password: '',
                loading: false,
            };
        },
        watch: {
            privateKey: function () {
                this.password = ''; // Reset password when new address is generated
            },
        },
        methods: {
            async save() {
                if (this.password) {
                    this.loading = true;
                    // Yield to UI thread to show loading state
                    await new Promise((resolve) => setTimeout(resolve, 50));

                    try {
                        const pk = this.privateKey.startsWith('0x') ? this.privateKey : '0x' + this.privateKey;
                        const wallet = new Wallet(pk);
                        const json = await wallet.encrypt(this.password);

                        const fileName = 'UTC--' + new Date().toISOString().replace(/:/g, '-') + '--' + this.address;
                        download(json, fileName, 'application/json');
                    } catch (e) {
                        console.error('Error encrypting wallet:', e);
                    } finally {
                        this.loading = false;
                    }
                }
            },
        },
    };
</script>

<style lang="sass">
    @import "~remodal/src/remodal.css"
    @import "~remodal/src/remodal-default-theme.css"
    @import "../css/variables"
    .remodal-overlay
        background: rgba(0, 0, 0, 0.85)

    .remodal
        background-color: $panel-background
        color: $text
        .title
            margin-bottom: 45px
        .remodal-close
            outline: none
            &:before
                font-size: 2em
            &:hover
                color: $text
        .hidden
            display: none
    .show-password
        position: absolute
        border: none
        font-size: 24px
        background: rgba(0,0,0,0)
        color: $text
        transform: translate(-50px, 12px)
        outline: none !important
        box-shadow: none !important
        -webkit-appearance: none
</style>
